<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <ListCategories />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListCategories from '@/views/categories/components/ListCategories'

export default {
  name: 'CategoriesManage',
  components: { ListCategories },
}
</script>

<style lang="css" scoped>
:focus {
  outline: -webkit-focus-ring-color none !important;
}
</style>
